import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { Container } from "../components/layout/Container";
import DashboardSidebar from "../components/dashboard/DashboardSidebar";
import DashboardOverview from "../components/dashboard/DashboardOverview";
import DashboardSavings from "../components/dashboard/DashboardSavings";
import DashboardComments from "../components/dashboard/DashboardComments";
import DashboardReviews from "../components/dashboard/DashboardReviews";
import DashboardLiked from "../components/dashboard/DashboardLiked";
import DashboardSettings from "../components/dashboard/DashboardSettings";
import { refreshUserPortfolio } from "../store/actions/userActions";
import useSEO from "../hooks/useSEO";

const Body = styled.div`
  padding: 2rem 0;
`;

const Flex = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  @media (min-width: 1024px) {
    flex-direction: row;
  }
`;

const Main = styled.div`
  flex: 1;
  min-width: 0;
`;

const Note = styled.p`
  margin: 0 0 1rem;
  font-size: 0.875rem;
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
`;

export default function DashboardPage() {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((s) => s.auth);
  const { error: portfolioError } = useSelector((s) => s.user);
  const { listError: likedListError } = useSelector((s) => s.couponLike);
  const [activeTab, setActiveTab] = useState("overview");

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(refreshUserPortfolio());
    }
  }, [isAuthenticated, dispatch]);

  const seo = useSEO({
    title: "My Dashboard",
    noindex: true,
    nofollow: true,
  });

  return (
    <>
      {seo}
      <Body>
      <Container>
        {isAuthenticated && (portfolioError || likedListError) && (
          <Note>
            Could not refresh account data: {portfolioError || likedListError}
          </Note>
        )}
        <Flex>
          <DashboardSidebar activeTab={activeTab} onTab={setActiveTab} />
          <Main>
            {activeTab === "overview" && <DashboardOverview />}
            {activeTab === "savings" && <DashboardSavings />}
            {activeTab === "comments" && <DashboardComments />}
            {activeTab === "reviews" && <DashboardReviews />}
            {activeTab === "liked" && <DashboardLiked />}
            {activeTab === "settings" && <DashboardSettings />}
          </Main>
        </Flex>
      </Container>
      </Body>
    </>
  );
}
